import { useTranslation } from "react-i18next"
import { Link } from "react-router"

export function MarketingFooter() {
  const { t } = useTranslation()
  const currentYear = new Date().getFullYear()

  return (
    <footer className="bg-gray-50 dark:bg-gray-900">
      <div className="container mx-auto px-4 py-12 lg:px-8 lg:py-16">
        <div className="grid grid-cols-2 gap-8 md:grid-cols-4">
          {/* Product */}
          <div>
            <h3 className="mb-6 text-sm font-semibold uppercase tracking-wider text-gray-900 dark:text-white">
              {t('common:footer.product')}
            </h3>
            <ul className="space-y-4 text-gray-600 dark:text-gray-400">
              <li>
                <Link to="/#features" className="hover:underline">
                  {t('common:navigation.features')}
                </Link>
              </li>
              <li>
                <Link to="/pricing" className="hover:underline">
                  {t('common:navigation.pricing')}
                </Link>
              </li>
            </ul>
          </div>

          {/* Company */}
          <div>
            <h3 className="mb-6 text-sm font-semibold uppercase tracking-wider text-gray-900 dark:text-white">
              {t('common:footer.company')}
            </h3>
            <ul className="space-y-4 text-gray-600 dark:text-gray-400">
              <li>
                <Link to="/faq-page" className="hover:underline">
                  {t('common:navigation.faq')}
                </Link>
              </li>
              <li>
                <Link to="/support" className="hover:underline">
                  {t('common:footer.contact')}
                </Link>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h3 className="mb-6 text-sm font-semibold uppercase tracking-wider text-gray-900 dark:text-white">
              {t('common:footer.legal')}
            </h3>
            <ul className="space-y-4 text-gray-600 dark:text-gray-400">
              <li>
                <Link to="/tos" className="hover:underline">
                  {t('common:footer.termsOfService')}
                </Link>
              </li>
              <li>
                <Link to="/privacy" className="hover:underline">
                  {t('common:footer.privacyPolicy')}
                </Link>
              </li>
            </ul>
          </div>

          {/* Brand */}
          <div>
            <Link to="/" className="text-2xl font-bold text-gray-900 dark:text-white font-[family-name:var(--font-heading)]">
              Offerty
            </Link>
            <p className="mt-4 text-sm text-gray-600 dark:text-gray-400">
              {t('marketing:slogan')}
            </p>
          </div>
        </div>

        {/* Copyright */}
        <hr className="my-8 border-gray-200 dark:border-gray-700" />
        <p className="text-center text-sm text-gray-600 dark:text-gray-400">
          © {currentYear} <span className="font-[family-name:var(--font-heading)] dark:text-white">Offerty</span>. {t('common:footer.allRightsReserved')}
        </p>
      </div>
    </footer>
  )
}